import RouterStore from './RouterStore';
import MeStore from './MeStore';
import NetworkStore from './NetworkStore';

// Store
class Store {
    routerStore = new RouterStore();
    meStore = new MeStore();
    networkStore = new NetworkStore();
}

const store = new Store();
export { store };
export type IStore = Store;
export default Store;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/Store.ts